
export const chatStatus = {
  CHIUSA: 0,
  MESSAGGIO_ENTE: 1, // L'ultimo messaggio è dell'ente
  MESSAGGIO_CITTADINO: 2, // L'ultimo messaggio è del cittadino
  TERMINATA: 3, // Chat chiusa dall'ente
};